import React from 'react'
import { Layout, Menu } from 'antd'
import { 
  HomeOutlined, 
  DatabaseOutlined, 
  BarChartOutlined,
  NodeIndexOutlined,
  SearchOutlined
} from '@ant-design/icons'
import { useNavigate, useLocation } from 'react-router-dom'

const { Sider } = Layout

const AppSider: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const menuItems = [
    {
      key: '/',
      icon: <HomeOutlined />,
      label: '系统首页',
    },
    {
      key: 'kg',
      icon: <DatabaseOutlined />,
      label: '知识图谱',
      children: [
        {
          key: '/kg',
          icon: <NodeIndexOutlined />,
          label: '图谱概览',
        },
        // {
        //   key: '/kg/search',
        //   icon: <SearchOutlined />,
        //   label: '图谱查询',
        // },
      ],
    },
    {
      key: 'stats',
      icon: <BarChartOutlined />,
      label: '统计报表',
      children: [
        {
          key: '/stats',
          icon: <BarChartOutlined />,
          label: '统计分析',
        },
      ],
    },
  ]

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key)
  }

  return (
    <Sider 
      width={250} 
      style={{ 
        background: '#fff',
        boxShadow: '2px 0 8px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div style={{ 
        padding: '16px', 
        textAlign: 'center',
        borderBottom: '1px solid #f0f0f0'
      }}>
        <DatabaseOutlined style={{ fontSize: '20px', color: '#1890ff' }} />
      </div>
      
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        style={{ borderRight: 0 }}
        items={menuItems}
        onClick={handleMenuClick}
      />
    </Sider>
  )
}

export default AppSider
